// Open modals own Escape wherever focus sits; a persistent listbox (DM timeline) must not block it.
export const OPEN_MODAL_SELECTOR = '[role="dialog"], [role="alertdialog"], [aria-modal="true"]';

const ESCAPE_OWNER_SELECTOR = `${OPEN_MODAL_SELECTOR}, [role="menu"], [role="listbox"], [role="combobox"]`;
const EDITABLE_TAGS: ReadonlySet<string> = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export interface EscapeKeyLike {
    key: string;
    defaultPrevented: boolean;
}

export interface FocusedElementLike {
    tagName: string;
    isContentEditable: boolean;
    closest(selector: string): unknown;
    getAttribute(name: string): string | null;
}

// A disclosure (card header, thread toggle) is also aria-expanded but has no popup for Esc to close.
function isOpenPopupTrigger(active: FocusedElementLike): boolean {
    const popup = active.getAttribute('aria-haspopup');
    return active.getAttribute('aria-expanded') === 'true' && popup != null && popup !== 'false';
}

function focusOwnsEscape(active: FocusedElementLike): boolean {
    if (EDITABLE_TAGS.has(active.tagName.toUpperCase()) || active.isContentEditable) return true;
    if (isOpenPopupTrigger(active)) return true;
    return active.closest(ESCAPE_OWNER_SELECTOR) != null;
}

// Escape leaves focus mode only when nothing else claimed it: no handler, input, menu or modal.
export function shouldEscapeExitFocusMode(
    event: EscapeKeyLike,
    active: FocusedElementLike | null,
    modalOpen: boolean
): boolean {
    if (event.key !== 'Escape' || event.defaultPrevented || modalOpen) return false;
    return active == null || !focusOwnsEscape(active);
}
